import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, OnDestroy, EventEmitter, Output } from '@angular/core';
import { from, Subject } from 'rxjs';
import { pathJoin, isNullOrWhitespace, showErrorSwal } from '@asamco/utils';
import { Company } from '../../interfaces/company.interface';
import { Router } from '@angular/router';
import { NgIf, NgStyle, NgClass, AsyncPipe, JsonPipe } from '@angular/common';
import { CompanyAccessRequestModalComponent } from '../company-access-request-modal/company-access-request-modal.component';
import Swal from 'sweetalert2';
import { SelectedCompanyService } from '../../selected-company/selected-company.service';

@Component({
    selector: 'al-subcompany-dashboard-tile',
    templateUrl: './subcompany-dashboard-tile.component.html',
    styleUrls: ['../../styles/alert.scss', '../../styles/tile-style.scss', './subcompany-dashboard-tile.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        NgStyle,
        NgClass,
        AsyncPipe,
		JsonPipe
    ],
})
export class SubcompanyDashboardTileComponent implements OnInit, OnDestroy {
	public imgUrl = '';
	@Input()
	item: Company;

	@Input()
	accessRequestModal: CompanyAccessRequestModalComponent;

	public destroy$: Subject<void> = new Subject<void>();

	constructor(
		private cdr: ChangeDetectorRef,
		private router: Router,
		private scs: SelectedCompanyService
	) {
		this.imgUrl = pathJoin([window['deployUrl'], '/assets/img/']);
	}

	ngOnInit(): void {
	}

	onCardClick($event) {
		if (this.item.userHasAccess) {
			from(this.scs.setCompanyId(this.item.id)).subscribe({
				error: error => showErrorSwal(error),
			});
		} else {
			this.accessRequestModal.show(this.item);
		}
	}

	public getUrl(subUrl: string): string {
		if (!isNullOrWhitespace(this.imgUrl) && !isNullOrWhitespace(subUrl)) {
			return pathJoin([this.imgUrl, subUrl]);
		}
		return '';
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
